module.exports = __webpack_public_path__ + "static/img/marker10.d7069cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marker10.png
// module id = A2TH
// module chunks = 0